import React from 'react';
import { HeaderBase } from './HeaderBase';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { logout } from '../../store/actions/user';
import { getAppConfig } from '../../store/selectors/appConfig';
import { getUserLocationId, getUserRole } from '../../store/selectors/user';
import { RootState } from '../../store/types';

export const Header: React.FC = () => {
    const dispatch = useAppDispatch();

    const page = useAppSelector((state: RootState) => state.page);
    const userName = useAppSelector((state: RootState) => state.user.computedUsername);
    const companyId = useAppSelector((state: RootState) => state.user.companyId);
    const appConfig = useAppSelector((state: RootState) => getAppConfig(state) || {});
    const locationId = useAppSelector((state: RootState) => getUserLocationId(state));
    const role = useAppSelector((state: RootState) => getUserRole(state));

    const handleLogout = () => {
        dispatch(logout());
    };

    return (
        <HeaderBase
            page={page ?? ''}
            userName={userName}
            companyId={companyId}
            appConfig={appConfig}
            locationId={locationId}
            role={role}
            logout={handleLogout}
        />
    );
};
